import classNames from "classnames";
import { ChipColor } from "./types";
import { BASE_CHIP_CLASS, BASE_TEXT_CLASS } from "./constants";

const useChip = (
  color: ChipColor,
  className?: string,
  textClassName?: string
) => {
  const hasCustomBackground = className?.includes?.("bg-");

  const colorClass = hasCustomBackground
    ? ""
    : `bg-fds-${color} text-fds-on-${color}`;

  const chipClass = classNames(BASE_CHIP_CLASS, colorClass, className);

  const textClass = classNames(BASE_TEXT_CLASS, textClassName);

  return {
    chipClass,
    textClass,
  };
};

export default useChip;
